import { makeAutoObservable } from 'mobx';

import {
  SOLUTION_TYPE_FILTER,
  SolutionTypeFilter,
  SolutionTypeFilterFlags,
} from '../../shared/constants/user-info/solutionType';
import { resetAllStore } from '../../shared/stores/resetAllStore';
import {
  DATE_RANGE_PRESETS,
  DateRangePreset,
} from '../../shared/constants/dateRangePreset';
import { getFlagsObject } from '../../shared/utils/sortingAndGroupingUtil';

class EntityDashboardFilterStore {
  solutionTypeFilter: SolutionTypeFilter = SOLUTION_TYPE_FILTER.ALL;
  dateRangePreset: DateRangePreset = DATE_RANGE_PRESETS['7D'];
  get solutionTypeFilterFlags(): SolutionTypeFilterFlags {
    return getFlagsObject(SOLUTION_TYPE_FILTER, [this.solutionTypeFilter]);
  }

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  setDefaultValues() {
    this.solutionTypeFilter = SOLUTION_TYPE_FILTER.ALL;
    this.dateRangePreset = DATE_RANGE_PRESETS['7D'];
  }

  setSolutionTypeFilter(solutionTypeFilter: SolutionTypeFilter) {
    this.solutionTypeFilter = solutionTypeFilter;
  }

  setDateRangePreset(dateRangePreset: DateRangePreset) {
    this.dateRangePreset = dateRangePreset;
  }
}

const entityDashboardFilterStore = new EntityDashboardFilterStore();

resetAllStore.addResetMethod(entityDashboardFilterStore.setDefaultValues);

export { entityDashboardFilterStore, EntityDashboardFilterStore };
